import React from "react";
import Quiz from "../Quiz";

const questions = [
  // Original multiple choice
  {
    questionText: "Which word is a noun?",
    options: ["Run", "Beautiful", "Happiness", "Quickly"],
    correct: "Happiness",
  },
  {
    questionText: "Choose the correct sentence.",
    options: [
      "Their going to school.",
      "There going to school.",
      "They're going to school.",
      "Theyre going to school.",
    ],
    correct: "They're going to school.",
  },

  // Comprehension
  {
    questionText: "According to the passage, what has made people more optimistic about living on other planets?",
    options: [
      "More oxygen on other planets",
      "Space exploration advances",
      "Aliens sending messages",
      "Stronger gravity",
    ],
    correct: "Space exploration advances",
  },
  {
    questionText: "What have scientists been doing to learn more about space?",
    options: [
      "Reading science fiction",
      "Sending robots to space to collect data",
      "Watching the stars",
      "Studying the moon only",
    ],
    correct: "Sending robots to space to collect data",
  },
  {
    questionText: "What is the main idea of the passage?",
    options: [
      "Aliens are real",
      "Planets are round",
      "Exploring and possibly living on other planets",
      "Gravity is strong on Mars",
    ],
    correct: "Exploring and possibly living on other planets",
  },
  {
    questionText: "What is the 'dream' of space exploration?",
    options: [
      "To become astronauts",
      "To explore new worlds",
      "To live on the moon only",
      "To build bigger rockets",
    ],
    correct: "To explore new worlds",
  },
  {
    questionText: "Why is it important to explore other planets?",
    options: [
      "To escape Earth’s problems",
      "To find new homes and gain knowledge",
      "To fight aliens",
      "To collect space dust",
    ],
    correct: "To find new homes and gain knowledge",
  },

  // Grammar: Fill in the blanks (reworded as multiple choice)
  {
    questionText: "By the time we arrive at the station, the train __________.",
    options: ["leave", "has left", "will have left", "is leaving"],
    correct: "will have left",
  },
  {
    questionText: "I __________ such an amazing movie before!",
    options: ["never saw", "have never seen", "see", "never seen"],
    correct: "have never seen",
  },
  {
    questionText: "She __________ to school every day, but today she __________ late.",
    options: ["runs / is", "run / was", "ran / are", "run / is"],
    correct: "runs / is",
  },
  {
    questionText: "My brother __________ me with my homework right now.",
    options: ["helps", "help", "is helping", "helping"],
    correct: "is helping",
  },
  {
    questionText: "They __________ their project by next week.",
    options: ["finished", "have finished", "will have finished", "finishing"],
    correct: "will have finished",
  },

  // Sentence reorder
  {
    questionText: "Reorder this sentence: friends / visiting / are / the / tomorrow",
    options: [
      "The friends are visiting tomorrow.",
      "Visiting friends are the tomorrow.",
      "Are visiting the friends tomorrow.",
      "Friends the are visiting tomorrow.",
    ],
    correct: "The friends are visiting tomorrow.",
  },
  {
    questionText: "Reorder this sentence: party / the / late / was / yesterday",
    options: [
      "The party was late yesterday.",
      "The late party was yesterday.",
      "Was the party late yesterday.",
      "Yesterday the party was late.",
    ],
    correct: "The party was late yesterday.",
  },

  // Word choice
  {
    questionText: "The story was so _______________ that I couldn’t stop reading it.",
    options: ["exciting", "excited"],
    correct: "exciting",
  },
  {
    questionText: "The book was ______________ on the shelf for weeks before I finally read it.",
    options: ["dusty", "dust"],
    correct: "dusty",
  },
  {
    questionText: "It is important to ________________ new words in your vocabulary every day.",
    options: ["learn", "learnt"],
    correct: "learn",
  },
  {
    questionText: "The scientist made a great ___________________ in the field of biology.",
    options: ["discovery", "discover"],
    correct: "discovery",
  },
  {
    questionText: "After reading the book, I felt ____________________ about the future.",
    options: ["hope", "hopeful"],
    correct: "hopeful",
  },

  // Capitalization and punctuation
  {
    questionText: "Correct this sentence: last year i went to johannesburg for a holiday.",
    options: [
      "Last year i went to Johannesburg for a holiday.",
      "last year I went to Johannesburg for a holiday.",
      "Last year I went to Johannesburg for a holiday.",
      "Last Year I went to Johannesburg for a holiday.",
    ],
    correct: "Last year I went to Johannesburg for a holiday.",
  },
  {
    questionText: 'Correct this sentence: we saw the film called “the secret garden” at the cinema.',
    options: [
      'We saw the film called “the secret garden” at the cinema.',
      'We saw the film called “The Secret Garden” at the cinema.',
      'we saw the film called “The Secret Garden” at the cinema.',
      'We saw the film called “The secret garden” at the cinema.',
    ],
    correct: 'We saw the film called “The Secret Garden” at the cinema.',
  },
];

export default function EnglishQuiz({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete}  />;
}

